import React, { useEffect, useState } from "react";
import { Layout, message } from "antd";
import { useHistory } from "react-router-dom";
import AppHeader from "./AppHeader";
import AppSider from "./AppSider";
import AppNav from "./AppNav";
import "./loading.less";
import { useModel, useModelDispatchers } from "../../models";
import AppRoute from "./AppRoute";
import Preview from "../../components/Preview";
import {
	setToken,
	getToken,
	setUserInfo,
	setUserMenu,
	setResources
} from "../../utils/constants.js";
import { loginServiceAuth2 } from "./LoginServiceAuth2";
const { Content } = Layout;

//域名解析
function urlParse(url) {
	let obj = {};
	/*
	 * 正则匹配
	 * [?&]:匹配?或&其一
	 * [^?&]:非?或非&
	 * */
	let reg = /[?&][^?&]+=[^?&]+/g;
	let arr = url.match(reg);
	if (arr) {
		arr.forEach((item) => {
			let tempArr = item.substring(1).split("=");
			let key = tempArr[0];
			let val = tempArr[1];
			obj[key] = val;
		});
	}
	return obj;
}

export default function () {
	const {
		getInvoiceTypeDict,
		getPurchaseOrderTypeDict,
		getPurchaseOrderStatusDict,
		getSupplierDict,
		getPurchasePayStatusDict,
		getOrgDict,
		getWarehouseDict,
		getAreaDict,
		getShelveDict,
		getPositionDict,
		getPayTypeDict,
		getBrandDict,
		getMaterialSortDict,
		getSupplierTypeDict,
		getEngineTypeDict,
		getMaterialUnitDict,
		getCustomerTypeDict,
		getAccountTypeDict,
		getPurchaseReturnPayStatusDict,
		getPurchaseReturnStatusDict,
		getSaleOrderTypeDict,
		getSalePriceTypeDict,
		getSaleOrderStatusDict,
		getCustomerDict,
		getSaleReturnPayStatusDict,
		getSaleReturnStatusDict,
		getSaleStatusDict,
		getWhOutStatusDict,
		getSalePayStatusDict,
		getStockCheckStatusDict,
	} = useModelDispatchers("cmDict");

	// const [{ loading }, { setAppCodes, loadGetUser, loadUserMenu }] = useModel("global");
	const { routerChange } = useModelDispatchers("nav");
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	useEffect(() => {
		if (loading) {
			getCustomerDict();
			getSupplierDict();
			getWarehouseDict(true);
			getAreaDict();
			getShelveDict();
			getPositionDict(true);
			getInvoiceTypeDict();
			getPurchaseOrderTypeDict();
			getPurchaseOrderStatusDict();
			getPurchasePayStatusDict();
			getOrgDict();
			getWarehouseDict();
			getPayTypeDict();
			getBrandDict();
			getMaterialSortDict();
			getSupplierTypeDict();
			getEngineTypeDict();
			getMaterialUnitDict();
			getCustomerTypeDict();
			getAccountTypeDict();
			getPurchaseReturnPayStatusDict();
			getPurchaseReturnStatusDict();
			getSaleOrderTypeDict();
			getSalePriceTypeDict();
			getSaleOrderStatusDict();
			getSaleReturnPayStatusDict();
			getSaleReturnStatusDict();
			getSaleStatusDict();
			getSalePayStatusDict();
			getWhOutStatusDict();
			getStockCheckStatusDict();
		}
	}, [loading]);


	useEffect(() => {
		// 用于处理门户登陆--简易版
		// var urls = "http://scm-csweb.laoniuche.cn/?token=" + "2bc4e732e192461c86a97118e1eaaaf4";
		// let appInfo = urlParse(urls);
		let appInfo = urlParse(window.location.href);
		if (appInfo.token) {
			setToken(appInfo.token);
			beforeLogin(appInfo.token)
		}
	}, []);

	//门户2 获取用户信息及所有权限
	const beforeLogin = async (token) => {
		let APPCODE = "scm-z";
		let menuArr = [];
		function findMenuAll(array) {
			array.forEach(item => {
				item.linkUrl && menuArr.push(item.linkUrl);
				if (item.children && item.children.length > 0)
					findMenuAll(item.children);
			})
		}
		try {
			let { menus, resources, roles, shops, ...userInfo } = await loginServiceAuth2.VerifyInfo({ sourceApp: APPCODE, token });
			setUserInfo(userInfo);
			findMenuAll(menus?.[APPCODE] ?? []);
			setUserMenu(menuArr);
			setResources(resources);
			setLoading(true);
			loginServiceAuth2.recordAppLoginInfo("scm-z", userInfo.userCode);
		} catch (error) { message.warning("获取权限失败，请重新登录") }

	};

	useEffect(() => {
		history.listen((location, action) => {
			if (action === "POP") {
			} else if (
				location.state &&
				location.state.hasOwnProperty("id") &&
				location.state.id
			) {
				routerChange(location.state.id);
			} else {
				// console.log("else");
			}
		}, []);
	});

	return (
		<>
			{loading ? (
				<Layout style={{ height: "100vh" }}>
					<AppSider />
					<Layout>
						<AppHeader />
						<AppNav />
						<Content
							style={{ padding: "0 10px", position: "relative" }}
							id="main"
						>
							<AppRoute />
						</Content>
						<Preview />
					</Layout>
				</Layout>
			) : (
					<div className="login">
						<div className="caseBlanche">
							<div className="rond">
								<div className="test"></div>
							</div>
							<div className="load">
								<p>loading</p>
							</div>
						</div>
					</div>
				)}
		</>
	);
}
